export const SET_VIEWING_USER = 'SET_VIEWING_USER';
export const SET_APP_USERS = 'SET_APP_USERS';